import { render, staticRenderFns } from "./AnalyticsResultChartsPatientStatusOutpatient.vue?vue&type=template&id=f367e730"
import script from "./AnalyticsResultChartsPatientStatusOutpatient.vue?vue&type=script&lang=js"
export * from "./AnalyticsResultChartsPatientStatusOutpatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports